import React, { useState } from 'react';
import SPADataTable from '@/components/admin/SysadminSPA/shared/SPADataTable';
import { getCustomColumns, getStandardColumns } from './columns';
import type { Program } from './useContentPrograms';
import useContentPrograms from './useContentPrograms';

interface ProgramsTableProps {
  custom: boolean;
}

// AIDEV-NOTE: Programs table composed from shared SPA infrastructure.
// Domain-specific parts: columns, data hook, archived toggle. "Add Program" lives in the page
// header (AddProgramMenu). Routed modals (reuse-program, programs/:programId/licenses) render via
// ProgramsPage's Outlet; the license count column links to the latter.
const ProgramsTable = ({ custom }: ProgramsTableProps) => {
  const { programs, archivedPrograms, isLoading } = useContentPrograms(custom);
  const [showArchived, setShowArchived] = useState(false);

  const columns = custom ? getCustomColumns() : getStandardColumns();
  const data = showArchived ? [...programs, ...archivedPrograms] : programs;

  return (
    <div className="tw-mt-4">
      <SPADataTable
        columns={columns}
        data={data}
        emptyMessage="No programs found."
        globalFilter={{ placeholder: 'Search programs...' }}
        isLoading={isLoading}
        loadingRows={25}
        rowClassName={(row: Program) => (row.archived ? 'tw-opacity-60' : '')}
        secondaryActionSlot={(
          <label className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-spa-secondary tw-cursor-pointer">
            <input
              checked={showArchived}
              className="tw-cursor-pointer focus-visible:tw-ring-2 focus-visible:tw-ring-spa-accent focus-visible:tw-outline-none"
              type="checkbox"
              onChange={e => setShowArchived(e.target.checked)}
            />
            Show Archived
          </label>
        )}
      />
    </div>
  );
};

export default ProgramsTable;
